import React, { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../context/Login/LoginContext";
import { useNavigate } from "react-router-dom";
import { API_LINKS } from "../../constant/Links";
import { request } from "../../utils/HttpRequest";
import Button from "../../elements/Button";
import { FaCartPlus, FaCheckCircle } from "react-icons/fa";
import { ROUTES } from "../../constant/Routes";
import { LoadingContext } from "../../context/Loading/LoadingContext";

const PacketNumbers = (props) => {
  const navigate = useNavigate();
  const loginContext = useContext(LoginContext);
  const loadingContext = useContext(LoadingContext);

  const [data, setData] = useState({});

  useEffect(() => {
    loadingContext.startLoading();
    fetchPacketNumbers();
  }, []);

  const fetchPacketNumbers = () => {
    request(
      API_LINKS.BASE + API_LINKS.PACKET_NUMBERS.RANGE,
      {
        laboratoryId: loginContext.userInfo.id,
      },
      (res) => {
        if (res.status) {
          setData({
            start: res.start,
            end: res.end,
          });
        }
        loadingContext.endLoading();
      },
      (err) => {
        alert("اشکال در برقراری ارتباط با سرور");
        loadingContext.endLoading();
      }
    );
  };

  const getNewPacketNumbers = () => {
    loadingContext.startLoading();
    request(
      API_LINKS.BASE + API_LINKS.PACKET_NUMBERS.ADD,
      {
        laboratoryId: loginContext.userInfo.id,
        amount: 200000,
        trackingCode: 1402140214021402,
      },
      (res) => {
        console.log(res);
        if (res.status) {
          setData({
            start: res.start,
            end: res.end,
          });
        } else {
          alert(res.msg);
        }
        loadingContext.endLoading();
      },
      (err) => {
        alert("اشکال در برقراری ارتباط با سرور");
        loadingContext.endLoading();
      }
    );
  };

  return (
    <section className="bg-lightPrimary dark:bg-darkPrimary ">
      <div className="grid place-items-center">
        <div className="bg-lightSecondary dark:bg-darkSecondary rounded-2xl  shadow-2xl p-4 m-5 w-11/12 sm:w-fit">
          {data.start == undefined ? (
            <div className="text-center sm:col-span-2">
              <h1 className="text-center text-2xl mb-4 dark:text-darkTextPrimary text-lightTextPrimary">
                {data.start == undefined ? "دریافت" : ""} شماره پاکت
              </h1>
              <Button
                extraClass="mt-4 mx-4 px-10 text-darkTextPrimary"
                type="submit"
                variant="success"
                content="دریافت بسته 1000 تایی شماره پاکت"
                rounded="rounded-2xl"
                icon={<FaCartPlus />}
                onClick={getNewPacketNumbers}
              />
            </div>
          ) : (
            <div className="text-center sm:col-span-2">
              <p>
                رنج شماره پاکت آزمایشگاه :{" "}
                <span className="font-bold">{loginContext.userInfo.name}</span>
              </p>
              <hr className="my-4" />
              <p>
                شروع: <span className="font-bold">{data.start}</span>
              </p>
              <p>
                پایان: <span className="font-bold">{data.end}</span>
              </p>
              <hr className="mt-4 mb-2" />
              <Button
                extraClass="mt-4 mx-4 px-10 text-darkTextPrimary"
                type="submit"
                variant="secondary"
                content="ثبت جواب ری"
                rounded="rounded-xl"
                icon={<FaCheckCircle />}
                onClick={() => {
                  navigate(ROUTES.ADDPAKAT);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PacketNumbers;
